import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { addFixatgeAsync } from '../../actions/controlPresenciaActions';
import { crearTotOkAction, uiAmagarDiaConsultatAction, uiAmagarIncidenciesAction, uiMostraIncidenciesAction } from '../../actions/ui';
import { FormulariIncidencia } from '../Incidencia/FormulariIncidencia';

// CORRECCIÓ: afegit estat local `enviant` per desactivar el botó durant la petició
// i evitar el doble submit que causava 2 fixatges d'entrada a la mateixa hora.

export const FormulariIniciJornada = () => {
  const dispatch = useDispatch();
  const [radioTipusControlPresencia, setRadioTipusControlPresencia] = useState('');
  const [enviant, setEnviant] = useState(false);
  const { t, i18n } = useTranslation('generic');

  const { auth, configUsuari, ui } = useSelector(
    state => ({
      auth: state.auth,
      configUsuari: state.configUsuari,
      ui: state.ui
    }),
    shallowEqual
  );

  const { incidencia, diaConsultat } = ui;

  const handleChange = useCallback((e) => {
    setRadioTipusControlPresencia(e.target.value);
  }, []);

  const handleChangeIncidencia = useCallback(() => {
    if (incidencia) {
      dispatch(uiAmagarIncidenciesAction());
    } else {
      dispatch(uiMostraIncidenciesAction());
      dispatch(uiAmagarDiaConsultatAction());
    }
  }, [dispatch, incidencia]);

  const enviarControlPresenciaEntrada = useCallback((e) => {
    e.preventDefault();

    if (!radioTipusControlPresencia) {
      dispatch(crearTotOkAction(t('FormulariFiIniciJornada.msgOkNoSelec')));
      return;
    }

    // Bloquejar immediatament per evitar doble submit
    if (enviant) return;
    setEnviant(true);

    dispatch(
      addFixatgeAsync(
        radioTipusControlPresencia,
        auth.tokenJwt,
        i18n.language,
        configUsuari?.contingut?.saltaUrlPortalComb
      )
    ).finally(() => {
      // Reactivar el botó quan la petició finalitza (ok o error)
      setEnviant(false);
    });

  }, [radioTipusControlPresencia, enviant, dispatch, auth.tokenJwt, i18n.language, configUsuari, t]);

  const radios = [
    { id: 'tipusRegistreInicial_Presencial', value: 1, label: t('FormulariFiIniciJornada.presencial') },
    { id: 'tipusRegistreInicial_Teletreball', value: 2, label: t('FormulariFiIniciJornada.teletreball') }
  ];

  return (
    <>
      <div className="row">
        {radios.map((radio, idx) => (
          <div key={radio.id} className={`col-md-4 ${idx === 0 ? 'offset-md-3' : ''}`}>
            <div className="form-check mb-3">
              <input
                type="radio"
                id={radio.id}
                className="form-check-input"
                name="tipusRegistreInicial"
                value={radio.value}
                onChange={handleChange}
                disabled={enviant}
              />
              <label className="form-check-label" htmlFor={radio.id}>
                {radio.label}
              </label>
            </div>
          </div>
        ))}
      </div>

      <div className="mb-3 text-center">
        <button
          type="button"
          onClick={enviarControlPresenciaEntrada}
          className="btn btn-primary btn-sm m-1"
          disabled={enviant}
        >
          {enviant
            ? <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>{t('Generics.enviant') || 'Enviant...'}</>
            : t('FormulariFiIniciJornada.enviar')
          }
        </button>
      </div>

      <div className="row">
        <p>
          {t('FormulariFiIniciJornada.PregIncidencia')}{' '}
          <button type="button" onClick={handleChangeIncidencia} className="btn btn-outline-primary btn-sm m-1 col-md-4" disabled={enviant}>
            {t('FormulariFiIniciJornada.incidencia')}
          </button>
        </p>
        {incidencia && !diaConsultat && <FormulariIncidencia />}
      </div>
    </>
  );
};

export default React.memo(FormulariIniciJornada);